module.exports = "/_next/static/images/becomePartnerPopUp-7b77c8a57efbae87bf229bf9fe59576a.svg";